export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4026c15f49b17919aebc943744bd38da5a393cd224&name=revalidateCommunity!'